/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import PatientTable from "components/tables/PatientTable";
import useHttp from "hooks/http.hook";
import { FC, useEffect, useState } from "react";
import { PatientInterface, QueryResultInterface } from "@malmur-technologies/medicalsystem-shared";
import { useNavigate } from "react-router-dom";
import { CoreAPI_URLs } from "constants/http.const";
import Box from "components/generals/Box";
import Button from "components/generals/Button";
import { useTranslation } from "react-i18next";
import { RoutesConstants } from "@malmur-technologies/medicalsystem-shared";
import PermissionWrapper from "components/generals/PermissionWrapper";
import { EntityPermissions, PermissionsUser } from "types";
import useSort from "hooks/useSort.hook";

/**
 * Component displaying paginated list of patients with search and navigation.
 * Provides table view of patient records with options to create new patients.
 * 
 * @returns Patient data content with table, pagination, and create button
 */
const PatientsDataContent: FC = () => {
  const [isLoading, _error, sendRequest] = useHttp();
  const [patientListResponse, setPatientListResponse] = useState<PatientInterface[]>([]);
  const [page, setPage] = useState<number>(1);
  const [pageTotal, setPageTotal] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [rowsTotal, setRowsTotal] = useState<number>(0);
  const [filterModel, setFilterModel] = useState<string>("");
  const { sortBy, sortOrder, handleSortChange, buildSortParam } = useSort();
  //use satate filter

  const navigate = useNavigate();

  function handleNewPatient() {
    navigate(RoutesConstants.NEW_PATIENT);
  }

  useEffect(() => {
    const nameParam = filterModel ? `name=${filterModel}&` : "";
    const url = `${CoreAPI_URLs.PATIENTS_GET_ALL}?${nameParam}${buildSortParam()}page=${page}&pageSize=${pageSize}`;

    sendRequest(url, onGetPatientHandler, "GET");
  }, [page, pageSize, filterModel, buildSortParam]);

  const onGetPatientHandler = (patientsResponse: QueryResultInterface<PatientInterface>) => {
    setPatientListResponse(patientsResponse.results);
    setRowsTotal(patientsResponse.total);
    setPageTotal(Math.ceil(patientsResponse.total / pageSize));
  };

  const { t } = useTranslation();

  return (
    <Box>
      <Box mt={2} mb={2} width="100%" display="flex" justifyContent="flex-end">
        <PermissionWrapper
          requiredPermissions={[PermissionsUser[EntityPermissions.PATIENTS].CREATE]}
        >
          <Button id="cy-new-patient-button" type="button" variant="contained" color="info" onClick={handleNewPatient}>
            {t("patientsDataContent.newPatient")}
          </Button>
        </PermissionWrapper>
      </Box>
      <PatientTable
        modelList={patientListResponse}
        setModelList={setPatientListResponse}
        canSearchPlaceholder={t("patientsDataContent.searchPatient")}
        entriesPerPage={{ defaultValue: pageSize }}
        setPageState={setPage}
        setPageSizeState={setPageSize}
        apiPagination={true}
        apiPageTotal={pageTotal}
        apiRowsTotal={rowsTotal}
        apiPageCurrentIndex={page}
        setModelFilter={setFilterModel}
        isLoading={isLoading}
        onSortChange={handleSortChange}
        currentSortBy={sortBy}
        currentSortOrder={sortOrder}
      />
    </Box>
  );
};

export default PatientsDataContent;
